import { render, staticRenderFns } from "./RequestNewTokenModal.vue?vue&type=template&id=a178603a&scoped=true&"
import script from "./RequestNewTokenModal.vue?vue&type=script&lang=ts&"
export * from "./RequestNewTokenModal.vue?vue&type=script&lang=ts&"
import style0 from "./RequestNewTokenModal.vue?vue&type=style&index=0&id=a178603a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a178603a",
  null
  
)

export default component.exports